// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link {
  text-decoration: underline;
  font-weight: 400;
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
}
.link:focus, .link:hover, .link:active {
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
}

.link--disabled {
  cursor: default;
  pointer-events: none;
  opacity: 0.4;
}
.link--disabled:focus::before {
  border: 0;
}

.link--black {
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
}
.link--black:hover, .link--black:focus, .link--black:active {
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
}
.link--black.link--disabled {
  cursor: default;
  pointer-events: none;
  opacity: 0.4;
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
}
.link--black.link--disabled:focus::before {
  border: 0;
}
.link--black.link--disabled:hover {
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
}
.link--black.link--disabled:focus, .link--black.link--disabled:active {
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
}

.link--grey {
  color: rgb(var(--colour-text-and-icon-3, 118, 118, 118));
}
.link--grey:hover, .link--grey:focus, .link--grey:active {
  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));
}
.link--grey.link--disabled {
  cursor: default;
  pointer-events: none;
  opacity: 0.4;
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
}
.link--grey.link--disabled:focus::before {
  border: 0;
}
.link--grey.link--disabled:hover {
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
}
.link--grey.link--disabled:focus, .link--grey.link--disabled:active {
  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));
}

.link--white {
  color: rgb(var(--colour-static-white, 255, 255, 255));
}
.link--white:hover, .link--white:focus, .link--white:active {
  color: rgb(var(--colour-static-light-grey, 245, 245, 245));
}
.link--white.link--disabled {
  cursor: default;
  pointer-events: none;
  opacity: 0.4;
  color: rgb(var(--colour-static-white, 255, 255, 255));
}
.link--white.link--disabled:focus::before {
  border: 0;
}
.link--white.link--disabled:hover {
  color: rgb(var(--colour-static-white, 255, 255, 255));
}
.link--white.link--disabled:focus, .link--white.link--disabled:active {
  color: rgb(var(--colour-static-white, 255, 255, 255));
}

.link--subtle {
  text-decoration: none;
}
.link--subtle:focus, .link--subtle:hover, .link--subtle:active {
  text-decoration: underline;
}

h1 .link,
h2 .link,
h3 .link,
h4 .link,
h5 .link,
h6 .link,
p .link {
  margin-bottom: 0;
  text-decoration: underline;
}
h1 .link .svg-icon,
h2 .link .svg-icon,
h3 .link .svg-icon,
h4 .link .svg-icon,
h5 .link .svg-icon,
h6 .link .svg-icon,
p .link .svg-icon {
  vertical-align: middle;
}
h1 .link:hover, h1 .link:focus, h1 .link:active,
h2 .link:hover,
h2 .link:focus,
h2 .link:active,
h3 .link:hover,
h3 .link:focus,
h3 .link:active,
h4 .link:hover,
h4 .link:focus,
h4 .link:active,
h5 .link:hover,
h5 .link:focus,
h5 .link:active,
h6 .link:hover,
h6 .link:focus,
h6 .link:active,
p .link:hover,
p .link:focus,
p .link:active {
  text-decoration: underline;
}
h1 .link--subtle,
h2 .link--subtle,
h3 .link--subtle,
h4 .link--subtle,
h5 .link--subtle,
h6 .link--subtle,
p .link--subtle {
  text-decoration: none;
}
h1 .link--subtle:focus, h1 .link--subtle:hover, h1 .link--subtle:active,
h2 .link--subtle:focus,
h2 .link--subtle:hover,
h2 .link--subtle:active,
h3 .link--subtle:focus,
h3 .link--subtle:hover,
h3 .link--subtle:active,
h4 .link--subtle:focus,
h4 .link--subtle:hover,
h4 .link--subtle:active,
h5 .link--subtle:focus,
h5 .link--subtle:hover,
h5 .link--subtle:active,
h6 .link--subtle:focus,
h6 .link--subtle:hover,
h6 .link--subtle:active,
p .link--subtle:focus,
p .link--subtle:hover,
p .link--subtle:active {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./node_modules/@ingka/hyperlink/dist/style.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,SAAS;AACX;;AAEA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,qDAAqD;AACvD;AACA;EACE,SAAS;AACX;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE,wDAAwD;AAC1D;AACA;EACE,qDAAqD;AACvD;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,qDAAqD;AACvD;AACA;EACE,SAAS;AACX;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,qDAAqD;AACvD;AACA;EACE,SAAS;AACX;AACA;EACE,qDAAqD;AACvD;AACA;EACE,qDAAqD;AACvD;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;;EAOE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;;;;;;;EAOE,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;;;;;EAmBE,0BAA0B;AAC5B;AACA;;;;;;;EAOE,qBAAqB;AACvB;AACA;;;;;;;;;;;;;;;;;;;EAmBE,0BAA0B;AAC5B","sourcesContent":[".link {\n  text-decoration: underline;\n  font-weight: 400;\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n}\n.link:focus, .link:hover, .link:active {\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n}\n\n.link--disabled {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.4;\n}\n.link--disabled:focus::before {\n  border: 0;\n}\n\n.link--black {\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n}\n.link--black:hover, .link--black:focus, .link--black:active {\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n}\n.link--black.link--disabled {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.4;\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n}\n.link--black.link--disabled:focus::before {\n  border: 0;\n}\n.link--black.link--disabled:hover {\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n}\n.link--black.link--disabled:focus, .link--black.link--disabled:active {\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n}\n\n.link--grey {\n  color: rgb(var(--colour-text-and-icon-3, 118, 118, 118));\n}\n.link--grey:hover, .link--grey:focus, .link--grey:active {\n  color: rgb(var(--colour-text-and-icon-1, 17, 17, 17));\n}\n.link--grey.link--disabled {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.4;\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n}\n.link--grey.link--disabled:focus::before {\n  border: 0;\n}\n.link--grey.link--disabled:hover {\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n}\n.link--grey.link--disabled:focus, .link--grey.link--disabled:active {\n  color: rgb(var(--colour-text-and-icon-2, 72, 72, 72));\n}\n\n.link--white {\n  color: rgb(var(--colour-static-white, 255, 255, 255));\n}\n.link--white:hover, .link--white:focus, .link--white:active {\n  color: rgb(var(--colour-static-light-grey, 245, 245, 245));\n}\n.link--white.link--disabled {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.4;\n  color: rgb(var(--colour-static-white, 255, 255, 255));\n}\n.link--white.link--disabled:focus::before {\n  border: 0;\n}\n.link--white.link--disabled:hover {\n  color: rgb(var(--colour-static-white, 255, 255, 255));\n}\n.link--white.link--disabled:focus, .link--white.link--disabled:active {\n  color: rgb(var(--colour-static-white, 255, 255, 255));\n}\n\n.link--subtle {\n  text-decoration: none;\n}\n.link--subtle:focus, .link--subtle:hover, .link--subtle:active {\n  text-decoration: underline;\n}\n\nh1 .link,\nh2 .link,\nh3 .link,\nh4 .link,\nh5 .link,\nh6 .link,\np .link {\n  margin-bottom: 0;\n  text-decoration: underline;\n}\nh1 .link .svg-icon,\nh2 .link .svg-icon,\nh3 .link .svg-icon,\nh4 .link .svg-icon,\nh5 .link .svg-icon,\nh6 .link .svg-icon,\np .link .svg-icon {\n  vertical-align: middle;\n}\nh1 .link:hover, h1 .link:focus, h1 .link:active,\nh2 .link:hover,\nh2 .link:focus,\nh2 .link:active,\nh3 .link:hover,\nh3 .link:focus,\nh3 .link:active,\nh4 .link:hover,\nh4 .link:focus,\nh4 .link:active,\nh5 .link:hover,\nh5 .link:focus,\nh5 .link:active,\nh6 .link:hover,\nh6 .link:focus,\nh6 .link:active,\np .link:hover,\np .link:focus,\np .link:active {\n  text-decoration: underline;\n}\nh1 .link--subtle,\nh2 .link--subtle,\nh3 .link--subtle,\nh4 .link--subtle,\nh5 .link--subtle,\nh6 .link--subtle,\np .link--subtle {\n  text-decoration: none;\n}\nh1 .link--subtle:focus, h1 .link--subtle:hover, h1 .link--subtle:active,\nh2 .link--subtle:focus,\nh2 .link--subtle:hover,\nh2 .link--subtle:active,\nh3 .link--subtle:focus,\nh3 .link--subtle:hover,\nh3 .link--subtle:active,\nh4 .link--subtle:focus,\nh4 .link--subtle:hover,\nh4 .link--subtle:active,\nh5 .link--subtle:focus,\nh5 .link--subtle:hover,\nh5 .link--subtle:active,\nh6 .link--subtle:focus,\nh6 .link--subtle:hover,\nh6 .link--subtle:active,\np .link--subtle:focus,\np .link--subtle:hover,\np .link--subtle:active {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
